import { Code } from 'constants/codes';

const ScheduleCalendarUrl = (
  CompanyId: number, 
  branchId: number,
  doctorList: string,
  startDate: string,
  endDate: string
): string => {
  return `${Code.Path.SERVER}custom/schedule?company_id=${CompanyId}&branch_id=${branchId}&doctor_list=${doctorList}&start_date=${startDate}&end_date=${endDate}`;
};

export const APIUrl = {
    ScheduleCalendar: ScheduleCalendarUrl,
  }